<template>
  <div class="header">
    <!-- 头部导航容器：蓝白主色调，固定顶部，适配三端 -->
    <header class="header-nav">
      <!-- 导航内容包裹层：控制最大宽度，居中对齐 -->
      <div class="header-container">
        <!-- 左侧Logo：蓝白色调 -->
        <div class="header-logo">
          <img src="https://res.roadlinkglb.com/icon/company/zouchuqu.png" alt="Logo" height="40" />
        </div>
  
        <!-- 中间PC端导航菜单（Pad/PC显示，手机隐藏） -->
        <nav class="header-menu pc-menu">
            <router-link 
            v-for="item in navList" 
            :key="item.path" 
            :to="item.path" 
            class="menu-item"
            active-class="menu-active"
            v-bind="item.path === '/' ? { exact: true } : {}"
            >
                {{ item.name }}
            </router-link>
            <select v-model="selectedLanguage" @change="handleLanguageChange" class="language-select">
                <option 
                    v-for="item in languageOptions" 
                    :key="item.value" 
                    :value="item.value"
                >
                    {{ item.label }}
                </option>
            </select>
        </nav>
  
        <!-- 右侧移动端菜单按钮（手机显示，Pad/PC隐藏） -->
        <div class="mobile-menu-btn" @click="toggleMobileMenu">
          <span class="btn-line"></span>
          <span class="btn-line"></span>
          <span class="btn-line"></span>
        </div>
      </div>
  
      <!-- 移动端折叠菜单（默认隐藏，点击按钮切换显示） -->
      <nav class="mobile-menu" v-show="isMobileMenuOpen">
        <router-link 
          v-for="item in navList" 
          :key="item.path" 
          :to="item.path" 
          class="mobile-menu-item"
          active-class="menu-active"
          :exact="item.path === '/'"
          @click.native="toggleMobileMenu"
        >
          {{ item.name }}
        </router-link>
        <hr class="nav-hr" />
        {{ languageTitle }}<select v-model="selectedLanguage" @change="handleLanguageChange" class="language-select">
                <option 
                    v-for="item in languageOptions" 
                    :key="item.value" 
                    :value="item.value"
                >
                    {{ item.label }}
                </option>
            </select>
      </nav>
    </header>
  </div>
</template>
  
<script>

export default {
    name: 'HeaderNav',
    data() {
        return {
            // 1. 导航菜单列表，初始化为空，后续根据语言动态加载
            navList: this.$commonSetting.header.navList,
            // 语言选项列表
            languageOptions: this.$commonSetting.header.languageOptions,
            languageTitle: this.$commonSetting.header.languageTitle,
            // 移动端菜单展开状态
            isMobileMenuOpen: false,
            // 选中的语言
            selectedLanguage: this.$language
        }
    },
    mounted() {
        // 组件挂载完成后，立即加载页面数据
        this.loadData()
    },
    methods: {
        loadData() {
            this.navList = this.$commonSetting.header.navList,
            console.log("navList:" + this.navList)
        },
        // 切换移动端菜单显示/隐藏
        toggleMobileMenu() {
            this.isMobileMenuOpen = !this.isMobileMenuOpen;
        },
        // 处理语言切换
        handleLanguageChange() {
            // 更新全局语言变量
            this.$setLanguage(this.selectedLanguage)
            // 刷新页面以应用新语言
            this.$router.go(0) 

        }
    }
}
</script>
  
<style scoped>
.header{
  /* 核心：固定最小高度，确保占位 */
  /* min-height: 64px; */
  /* 可选：防止内容溢出时破坏布局 */
  box-sizing: border-box;
  /* 可选：若需要头部完全占据64px（而非“至少”），可替换为 height: 64px; */
  /* height: 64px; */
  /* 可选：内容垂直居中，提升视觉效果 */
  display: flex;
  align-items: center;
  /* 可选：防止内容超出容器 */
  overflow: hidden;
}
/* 头部导航核心样式：蓝白主色调 */
.header-nav {
  width: 100%;
  background-color: #ffffff; /* 白色背景 */
  /* border-bottom: 1px solid #e3f2fd;  */
  /* box-shadow: 0 2px 8px rgba(30, 136, 229, 0.1); */
  position: fixed; /* 固定顶部，保持导航可见 */
  top: 0;
  left: 0;
  z-index: 999; /* 提高层级，防止被其他内容遮挡 */
}
  
/* 内容容器：控制最大宽度，居中对齐，适配不同屏幕 */
.header-container {
  width: 100%;
  margin: 0 auto;
  display: flex;
  /* 关键修改1：flex-wrap: wrap 允许子元素换行 */
  flex-wrap: wrap;
  justify-content: space-between;
  /* 关键修改2：align-items 改为 flex-start，避免换行后垂直居中导致的留白问题 */
  align-items: flex-start;
  /* 关键修改3：移除固定 height，改用 min-height 保证最小高度，内容多则自动撑开 */
  min-height: 64px;
  /* 可选：添加内边距，避免内容贴边 */
  padding: 8px 0;
  /* 可选：添加行间距，优化换行后的排版 */
  gap: 8px 16px; /* 纵向8px，横向16px，flex布局的间距优化 */
  /* 可选：保证容器基线对齐，提升视觉一致性 */
  align-content: flex-start;
}


/* 左侧Logo样式 */
.header-logo{
  margin-left: 20px;
  font-weight: 600;
  cursor: pointer;
  transition: color 0.3s ease;
}
  
/* PC端导航菜单样式（默认显示，移动端隐藏） */
.pc-menu {
  margin-top: 8px;
  margin-right: 30px;
  display: flex;
  gap: 32px; /* 菜单项间距，提升美观度 */
}
  
/* 普通状态：深灰文字，透明背景（优化内边距，为激活状态蓝底预留空间） */
.menu-item {
  color: #000; /* 深灰文字，保证可读性 */
  font-size: 14px;
  border-radius: 14px; /* 圆角优化，提升视觉质感 */
  font-weight: 500;
  padding: 8px 16px; /* 左右增加内边距，激活状态蓝底更美观，上下保持原有间距 */
  position: relative;
  transition: all 0.3s ease; /* 过渡效果扩展为all，背景+文字色同步动画 */
}
  
/* 激活状态样式：白字蓝底（核心优化） */
.menu-active {
  color: #ffffff; /* 白色文字，满足需求 */
  background-color: #265FFF; /* 主蓝色背景，呼应整体蓝白色调 */
}
  
/* 移除原来的下划线样式（不再需要） */
/* 注释掉原有下划线代码
.menu-active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #1e88e5;
  border-radius: 1px;
}
*/
  
/* 普通状态hover：浅蓝背景+深蓝文字，与激活状态区分 */
.menu-item:hover {
  color: #fff;
  background-color: #265FFF; /* 浅蓝背景，提升交互体验，不与激活状态冲突 */
}
  
/* 移动端菜单按钮（默认隐藏，移动端显示） */
.mobile-menu-btn {
  margin: 10px;
  display: none;
  flex-direction: column;
  gap: 4px;
  cursor: pointer;
  padding: 4px;
}
  
.btn-line {
  width: 24px;
  height: 2px;
  background-color: #1e88e5; /* 主蓝色，呼应整体色调 */
  border-radius: 1px;
  transition: all 0.3s ease;
}
  
/* 移动端折叠菜单（默认隐藏，点击按钮切换） */
.mobile-menu {
  text-align: center;
  display: none;
  background-color: #ffffff;
  border-bottom: 1px solid #e3f2fd;
  padding: 16px 0;
}
  
/* 移动端普通状态：调整内边距，预留蓝底空间 */
.mobile-menu-item {
  display: block;
  padding: 12px 20px;
  color: #546e7a;
  font-size: 14px;
  font-weight: 500;
  border-radius: 4px; /* 统一圆角风格，与PC端保持一致 */
  margin: 0 16px; /* 左右边距，避免蓝底贴边 */
  transition: all 0.3s ease; /* 过渡效果扩展为all，背景+文字色同步动画 */
}
  
/* 移动端激活/hover状态：白字蓝底（与PC端保持样式统一） */
.mobile-menu-item:hover,
.mobile-menu-item.menu-active {
  background-color: #265FFF; /* 主蓝色背景 */
  color: #ffffff; /* 白色文字 */
  /* 移除原有浅蓝背景，替换为与PC端一致的白字蓝底 */
  /* 注释掉原有移动端样式
  background-color: #e3f2fd;
  color: #1e88e5;
  */
}
  
/* 响应式适配：三端兼容（媒体查询） */
/* 1. Pad端（平板）：屏幕宽度 768px - 1024px */
@media (max-width: 1024px) {
  .header-logo{
    margin-left: 0px;
  }
  .pc-menu {
    gap: 24px; /* 缩小菜单间距，适配平板宽度 */
  }
  
  .header-container {
    height: 60px; /* 略微降低头部高度，适配平板视觉 */
  }
}
  
/* 2. 手机端（小屏设备）：屏幕宽度 ≤ 768px */
@media (max-width: 768px) {
  .header-logo{
    margin-left: 0px;
  }

  /* 隐藏PC端菜单 */
  .pc-menu {
    display: none;
  }
  
  /* 显示移动端菜单按钮 */
  .mobile-menu-btn {
    display: flex;
  }
  
  /* 移动端折叠菜单改为块级显示（通过v-show控制切换） */
  .mobile-menu {
    display: block;
  }
  
  .header-container {
    height: 56px; /* 进一步降低头部高度，适配手机屏幕 */
  }
}
  
/* 页面主体内容间距（防止被固定头部遮挡） */
body {
  padding-top: 64px;
}
  
/* 响应式调整主体内边距，适配不同头部高度 */
@media (max-width: 1024px) {
  body {
    padding-top: 60px;
  }
}
  
@media (max-width: 768px) {
  body {
    padding-top: 56px;
  }
}

.language-select {
  width:auto;
  padding: 8px 16px;
  border: 1px solid #e6e6e6;
  border-radius: 4px;
  outline: none;
  cursor: pointer;
}
.language-select:hover {
  border-color: #1890ff;
}

.nav-hr {
  margin: 10px auto;
  border: none;          /* 清除默认边框 */
  height: 1px;           /* 横线粗细 */
  background-color: #e5e7eb; /* 横线颜色 */
  width: 90%;            /* 宽度90% */
}
</style>